const TEXT = 'text'
const NOTIFICATION = 'notification'
const IMAGE = 'image'

export { TEXT, NOTIFICATION, IMAGE }
